import React, { useState } from "react";
import { FiFilter, FiSearch, FiX, FiDownload } from "react-icons/fi";
import { deviceDummyData } from "../../../Data/DeviceData";

const TYPE_META = {
  Error:   { color: "#ef4444", bg: "#fee2e2", dot: "#ef4444" },
  Warning: { color: "#f59e0b", bg: "#fef3c7", dot: "#f59e0b" },
  Info:    { color: "#3b82f6", bg: "#dbeafe", dot: "#3b82f6" },
};

const DvcEventsPanel = () => {
  const [search, setSearch]     = useState("");
  const [filterType, setFilterType] = useState("All");
  const [filterDevice, setFilterDevice] = useState("All");

  const deviceNames = ["All", ...new Set(deviceDummyData.events.map(e => e.deviceName))];

  const filtered = deviceDummyData.events.filter(ev => {
    if (filterType !== "All" && ev.type !== filterType) return false;
    if (filterDevice !== "All" && ev.deviceName !== filterDevice) return false;
    if (search) {
      const q = search.toLowerCase();
      return ev.msg.toLowerCase().includes(q) || ev.deviceName.toLowerCase().includes(q);
    }
    return true;
  });

  const counts = { Error: 0, Warning: 0, Info: 0 };
  deviceDummyData.events.forEach(e => { counts[e.type] = (counts[e.type] || 0) + 1; });

  return (
    <div className="dvc-events-panel">
      {/* Summary */}
      <div className="dvc-alert-summary">
        {Object.entries(counts).map(([type, cnt]) => {
          const m = TYPE_META[type];
          return (
            <div key={type} className="dvc-alert-chip" style={{ background: m.bg, color: m.color, borderColor: m.color + "66" }}>
              {cnt} {type}
            </div>
          );
        })}
        <button className="dvc-ctrl-btn dvc-ctrl-blue" style={{ marginLeft: "auto", gap: 5 }}>
          <FiDownload size={13} /> Export Log
        </button>
      </div>

      {/* Filters */}
      <div className="dvc-filter-bar">
        <div className="dvc-search-wrap">
          <FiSearch size={14} color="#9ca3af" />
          <input className="dvc-search" placeholder="Search events…" value={search} onChange={e => setSearch(e.target.value)} />
          {search && <button style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af" }} onClick={() => setSearch("")}><FiX size={14} /></button>}
        </div>
        <div className="dvc-filter-group">
          <FiFilter size={13} color="#6b7280" />
          {["All", "Error", "Warning", "Info"].map(t => (
            <button key={t} className={`dvc-view-btn ${filterType === t ? "dvc-view-active" : ""}`} onClick={() => setFilterType(t)}>{t}</button>
          ))}
          <select className="dvc-filter-sel" value={filterDevice} onChange={e => setFilterDevice(e.target.value)}>
            {deviceNames.map(n => <option key={n}>{n}</option>)}
          </select>
        </div>
      </div>

      {/* Timeline */}
      <div className="dvc-event-timeline">
        {filtered.map((ev, i) => {
          const m = TYPE_META[ev.type] || TYPE_META.Info;
          return (
            <div key={ev.id} className="dvc-ev-entry">
              <div className="dvc-ev-timeline-col">
                <div className="dvc-ev-dot-lg" style={{ background: m.dot }} />
                {i < filtered.length - 1 && <div className="dvc-ev-line" />}
              </div>
              <div className="dvc-ev-content">
                <div className="dvc-ev-top-row">
                  <span style={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{ev.deviceName}</span>
                  <span style={{ padding: "1px 8px", borderRadius: 10, background: m.bg, color: m.color, fontSize: 11, fontWeight: 700 }}>{ev.type}</span>
                  <span style={{ fontSize: 11, color: "#9ca3af" }}>{ev.time}</span>
                  <span style={{ fontSize: 11, color: "#6b7280", marginLeft: "auto" }}>by {ev.user}</span>
                </div>
                <div style={{ fontSize: 12, color: "#374151", marginTop: 4 }}>{ev.msg}</div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2, fontFamily: "monospace" }}>{ev.id} · {ev.deviceId}</div>
              </div>
            </div>
          );
        })}
        {filtered.length === 0 && (
          <div className="dvc-empty" style={{ padding: 40 }}>No events match current filters</div>
        )}
      </div>
    </div>
  );
};

export default DvcEventsPanel;
